import { fromJS } from 'immutable';
import { mergeEntity, normalizeEntities } from 'helpers/utilHelpers';

import {
  LOAD_ARTICLES_SUCCESS,
  LOAD_ARTICLE_CATEGORIES_SUCCESS,
  LOAD_ARTICLE_TAGS_SUCCESS,
  LOAD_CATEGORIES_LAST_ARTICLES_SUCCESS,
  LOAD_ARTICLE_BY_ID_SUCCESS,
  UPDATE_ARTICLE_SUCCESS,
  UPDATE_ARTICLE_CATEGORY_SUCCESS,
  UPDATE_ARTICLE_TAG_SUCCESS,
  DELETE_ARTICLE_SUCCESS,
  DELETE_ARTICLE_CATEGORY_SUCCESS,
  DELETE_ARTICLE_TAG_SUCCESS,
  LOAD_ARTICLES_LIST_SUCCESS,
  CLEAR_ARTICLE_CATEGORIES,
  CLEAR_ARTICLE_TAGS,
} from 'constants/ActionTypes';

const initialState = fromJS({
  articles: {},
  articleCategories: {},
  articleCategoriesPagination: {},
  articleTags: {},
});

/**
 * Function for change array field: `tags` in article
 * @param article
 * @param tags - array
 * @param categories - array
 * @return new article
 */
const prepareArticle = (article) => {
  const excludingArticle = ['category'];

  if (article?.files?.length) {
    article.files = article.files.map((file) => file.fileId);
  }

  excludingArticle.forEach((field) => delete article[field]);

  return article;
};

const articlesReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_ARTICLES_LIST_SUCCESS:
    case LOAD_ARTICLES_SUCCESS: {
      let newState = state;
      if (action.categoryId) {
        newState = newState.setIn(['articleCategoriesPagination', action.categoryId], action.articles._meta);
        newState = newState.setIn(
          ['articleCategoriesPagination', action.categoryId, 'showMore'],
          action.articles._meta.currentPage !== action.articles._meta.pageCount,
        );
      }

      const articles = action.articles.items.map((article) => prepareArticle({ ...article }));
      return newState.set('articles', normalizeEntities(articles, 'articleId', state.get('articles')));
    }
    case LOAD_ARTICLE_BY_ID_SUCCESS: {
      const article = prepareArticle({ ...action.article });

      return state.setIn(
        ['articles', article.articleId],
        mergeEntity(article, state.getIn(['articles', article.articleId])),
      );
    }
    case LOAD_CATEGORIES_LAST_ARTICLES_SUCCESS: {
      const articles = [];

      action.articles.items.forEach((category) => {
        category.lastArticles &&
          category.lastArticles.forEach((article) => {
            articles.push(prepareArticle(article));
          });
      });

      return state.set('articles', normalizeEntities(articles, 'articleId', state.get('articles')));
    }
    case LOAD_ARTICLE_CATEGORIES_SUCCESS:
      return state.set('articleCategories', normalizeEntities(action.articleCategories.items, 'categoryId'));
    case CLEAR_ARTICLE_CATEGORIES:
      return state.set('articleCategories', initialState.get('articleCategories'));
    case LOAD_ARTICLE_TAGS_SUCCESS:
      return state.set('articleTags', normalizeEntities(action.articleTags.items, 'tagId'));
    case CLEAR_ARTICLE_TAGS: {
      return state.set('articleTags', initialState.get('articleTags'));
    }
    case UPDATE_ARTICLE_SUCCESS: {
      const article = prepareArticle({ ...action.article });
      return state.setIn(
        ['articles', article.articleId],
        mergeEntity(article, state.getIn(['articles', article.articleId])),
      );
    }
    case UPDATE_ARTICLE_CATEGORY_SUCCESS: {
      const category = { ...action.category };
      return state.setIn(
        ['articleCategories', category.categoryId],
        mergeEntity(category, state.getIn(['articleCategories', category.categoryId])),
      );
    }
    case UPDATE_ARTICLE_TAG_SUCCESS: {
      const tag = { ...action.tag };
      return state.setIn(['articleTags', tag.tagId], mergeEntity(tag, state.getIn(['articleTags', tag.tagId])));
    }
    case DELETE_ARTICLE_SUCCESS:
      return state.deleteIn(['articles', action.articleId]);
    case DELETE_ARTICLE_CATEGORY_SUCCESS:
      return state.deleteIn(['articleCategories', action.categoryId]);
    case DELETE_ARTICLE_TAG_SUCCESS:
      return state.deleteIn(['articleTags', action.tagId]);
    default:
      return state;
  }
};

export default articlesReducer;
